import { useState } from "react";
import StudentSidebar from "./StudentSidebar";
import "../../assets/styles/sliderBar.css";

function StudentLayout({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="dashboard">

      {/* TOP BAR */}
      <div className="student-topbar">
        <button className="student-menu-btn" onClick={() => setOpen(!open)}>
          ☰
        </button>
      </div>

      {/* SIDEBAR */}
      <StudentSidebar open={open} setOpen={setOpen} />

      {/* MAIN CONTENT */}
      <div className="main-content">
        {children}
      </div>

    </div>
  );
}

export default StudentLayout;